import { render, staticRenderFns } from "./FieldGlossary.vue?vue&type=template&id=3f2a8c5e&scoped=true"
import script from "./FieldGlossary.vue?vue&type=script&lang=js"
export * from "./FieldGlossary.vue?vue&type=script&lang=js"
import style0 from "./FieldGlossary.vue?vue&type=style&index=0&id=3f2a8c5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2a8c5e",
  null
  
)

export default component.exports